import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const DEFAULT_MIN_SEARCH_TEXT_LENGTH = 3;

export const searchBoxInputs = [
  {
    name: "resultsPage",
    type: "url",
    defaultValue: "/search-results",
  },
  {
    name: "minSearchTextLength",
    type: "number",
    friendlyName: "Minimum search text length to enable search",
    defaultValue: DEFAULT_MIN_SEARCH_TEXT_LENGTH,
  },
  {
    name: "translations",
    type: "object",
    required: true,
    subFields: [
      {
        name: "title",
        type: "string",
      },
      {
        name: "searchResultsLabel",
        friendlyName: "Results query label above search input",
        type: "string",
        required: true,
        description: "Should include {query} substring to make replaceable with a real search text",
      },
      {
        name: "resultsLabel",
        friendlyName: "Results number label below search input",
        type: "string",
        required: true,
        description: "Should include {count} substring to make replaceable with a real number of results",
      },
      {
        name: "placeholder",
        type: "string",
        required: true,
      },
      {
        name: "buttonLabel",
        friendlyName: "Search button text",
        type: "string",
        required: true,
      },
    ],
    defaultValue: {
      title: "Search",
      searchResultsLabel: "Search Results for '{query}'",
      resultsLabel: "{count} Results",
      placeholder: "Type to search",
      buttonLabel: "Search",
    },
  },
] as const satisfies Inputs;

export const SearchBoxComponent: RegisteredComponent = {
  name: "Search Form",
  component: dynamic(async () => withValidation(searchBoxInputs, (await import("./SearchBox")).SearchBox, "SearchBox")),
  inputs: searchBoxInputs,
};
